document.addEventListener('DOMContentLoaded', function () {
  var companyInput = document.getElementById('companySearchInput');
  var suggestionsList = document.getElementById('companySuggestions');

  if (!companyInput || !suggestionsList) return;

  var debounceTimer;

  companyInput.addEventListener('input', function () {
    var q = this.value.trim();
    clearTimeout(debounceTimer);

    if (q.length < 2) {
      hideSuggestions();
      return;
    }

    debounceTimer = setTimeout(function () {
      fetch('/api/company-suggest?q=' + encodeURIComponent(q))
        .then(function (res) {
          return res.json();
        })
        .then(function (names) {
          renderSuggestions(names);
        })
        .catch(function () {
          hideSuggestions();
        });
    }, 300);
  });

  companyInput.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      hideSuggestions();
    }
  });

  document.addEventListener('click', function (e) {
    if (!companyInput.contains(e.target) && !suggestionsList.contains(e.target)) {
      hideSuggestions();
    }
  });

  function renderSuggestions(names) {
    suggestionsList.innerHTML = '';

    if (!names.length) {
      hideSuggestions();
      return;
    }

    names.forEach(function (name) {
      var li = document.createElement('li');
      li.className = 'search__suggestion-item';
      li.textContent = name;
      li.addEventListener('click', function () {
        companyInput.value = name;
        hideSuggestions();
        companyInput.closest('form').submit();
      });
      suggestionsList.appendChild(li);
    });

    suggestionsList.style.display = 'block';
  }

  function hideSuggestions() {
    suggestionsList.innerHTML = '';
    suggestionsList.style.display = 'none';
  }
});
